export const OPERATION_TYPE = {
  withdrawBind: 'withdrawBind',
  confirmBind: 'confirmBind',
  denyBind: 'denyBind',
  unbindAccount: 'unbindAccount',
  withdrawUnbind: 'withdrawUnbind',
  confirmUnbind: 'confirmUnbind',
};
